import * as React from 'react';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { getIconCSSForFileProvider } from 'owa-fileprovider-icon';
import { observer } from 'mobx-react';

const styles = require('./FileProvidersToAddListView.scss');

export interface FileProviderToAddInfo {
    providerType: AttachmentDataProviderType;
    providerName: string;
    onClick: () => void;
}

export interface FileProvidersToAddListViewProps {
    providersToAddInfo: FileProviderToAddInfo[];
}

@observer
export default class FileProvidersToAddListView extends React.Component<
    FileProvidersToAddListViewProps,
    {}
> {
    render() {
        return (
            <div className={styles.container}>
                {this.props.providersToAddInfo.map(info => {
                    const icon = getIconCSSForFileProvider(info.providerType);

                    return (
                        <div
                            key={info.providerType}
                            className={styles.providerContainer}
                            title={info.providerName}>
                            <div className={styles.providerIcon} onClick={info.onClick}>
                                {icon}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}
